// extracted by mini-css-extract-plugin
export default {"brass-dialog":"Dialog_brass-dialog__8IrQ7","brass-dialog-align-right":"Dialog_brass-dialog-align-right__DRV9a","dialog-title-with-icon":"Dialog_dialog-title-with-icon__6oocW"};